import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import { IAssignTourPayload, IReassignTourPayload } from "../interfaces/Index";
import TourAssignmentPage from "../components/pages/tourAssignment/TourAssignmentPage";

export const mapStateToProps = (state: any, props: any) => {
  return {
    isLoading: state.shipper.isLoading,
    isError: state.shipper.isError,
    error: state.shipper.error,
    isTourAssigned: state.shipper.isTourAssigned,
    isCsvUploaded: state.shipper.isCsvUploaded,
    isEdit: false,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    assignTour: (payload: IAssignTourPayload) =>
      dispatch(actions.assignTour(payload)),
    reassignTour: (payload: IReassignTourPayload) =>
      dispatch(actions.reassignTour(payload)),
    uploadTourCsv: (payload: FormData, url: string) =>
      dispatch(actions.uploadTourCsv(payload, url)),
  };
};

const TourAssignmentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TourAssignmentPage);
export default TourAssignmentContainer;
